import axios from 'axios';
import { isAuthenticatedUser } from './auth';

let totalNoInternetRequest = 0;

const customAxios = axios.create();


// Request interceptor for API calls
customAxios.interceptors.request.use(
    async config => {
        if (isAuthenticatedUser()) {
            config.headers['Authorization'] = `Bearer ${localStorage.getItem("token")}`;
        }

        return config; 
    },
    error => {
        Promise.reject(error)
    }
);

customAxios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        const response = {
            code: 0,
            data: error?.response?.data,
        };
        
        throw response;
    }
);

export { customAxios };
